import { Typography } from "@mui/material";
import { IRunEvent } from "../../interface/IRunEvent"
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Chip from '@mui/material/Chip';
import { alpha, useTheme } from '@mui/material/styles';
import moment from 'moment'
import { GREEN, RED } from "../../Theme/theme";
import { formatPrice } from "../../utils/formatPrice";

interface LogItemProps
{
  row: IRunEvent
  setShowOrderDetails: (runEvent: IRunEvent | undefined) => void
}

export const LogItem = ({ row, setShowOrderDetails }: LogItemProps) =>
{
  const theme = useTheme()
  const formatNumber = (number: number) =>
  {
    try
    {
      return number.toFixed(2)
    }
    catch(error)
    {
      return "unknown"
    }
  }

  const isError = () =>
  {
    if(!row.didBuy && !row.didSell) return true
    return false
  }

  const isAiHold = row.strategy === "AIChecker" && !row.didBuy && !row.didSell &&
    row.buyResult?.startsWith("AIChecker HOLD:")

  return(
    <TableRow
      key={row._id}
      hover
      sx={{
        cursor: "pointer",
        '& td': {
          borderBottomColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.06 : 0.35),
        },
        backgroundColor: row.didSell
          ? alpha("#66BB6A", 0.06)
          : row.didBuy
            ? alpha("#64B5F6", 0.06)
            : isAiHold
              ? alpha(theme.palette.text.primary, theme.palette.mode === "dark" ? 0.05 : 0.035)
            : alpha("#EF5350", 0.05),
      }}
      onClick={() => setShowOrderDetails(row)}
    >
    <TableCell component="th" scope="row">
      <Typography variant="body2">{moment(row.timestamp).format("lll")}</Typography>
      <Typography variant="caption" sx={{ color: alpha(theme.palette.text.primary, 0.62) }}>
        {moment(row.timestamp).fromNow()}
      </Typography>
    </TableCell>
    <TableCell align="right">
      {row.marketId}
      {row.strategy === "AIChecker" && <Chip size="small" label={isAiHold ? "HOLD" : "AI"} sx={{ ml: 1 }} />}
    </TableCell>
    <TableCell align="right">{row.didSell ? row.sellResult : row.buyResult}</TableCell>
    <TableCell align="right">${formatPrice(row.lastPrice)}</TableCell>
    <TableCell align="right">{row.cryptoAmount || "-"}</TableCell>
    <TableCell align="right">${row.amount}</TableCell>

    <TableCell align="center">
      
      { row.profitKnown === false ? "Unknown" : isError() ? "-" : (
        <Chip
          label={`$${row.profit} ${row && row.percentProfit ? `(${row.percentProfit}%)` : ""}`}
          sx={{
            color: 'white',
            backgroundColor: row.profit > 0 ? GREEN : RED,
            borderRadius: "999px",
            fontWeight: 700,
          }}
        />
      ) }

    </TableCell>
    
    <TableCell align="right">${row.tradeFee ? `${row.tradeFee}`: 0}</TableCell>
    <TableCell align="right">{row.rsi || "-"}</TableCell>
    <TableCell align="right">{row.mfi || "-"}</TableCell>

    <TableCell align="right">${row.totalAssets ? formatNumber(row.totalAssets) : 0}</TableCell>

  </TableRow>
  )
}
